// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-border-dimension-control {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.softlite-border-dimension-control .components-text-control {
    flex: 1;
    margin-right: 5px;
}

.softlite-border-dimension-control .components-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    padding: 0;
}

.softlite-border-dimension-control .linked {
    background-color: #007cba;
    color: white;
}
.softlite-no-border-right .components-input-control__container input.components-input-control__input{
    border-right: none;
}
.softlite-border-control .components-input-control__container input.components-input-control__input{
    border-radius: 0px;
    border: 1px solid #949494;
    border-right: none;
}
.softlite-border-control .components-input-control__container input.components-input-control__input:focus{
    border: 1px solid #949494;
    border-right: none;
    outline: none;
    box-shadow: none;
}
.softlite-no-border-right .components-input-control__container input.components-input-control__input:focus{
    border-right: none;
}
.softlite-button-linked{
    border: 1px solid #949494;
    outline: none;
}
.softlite-border-control button.softlite-button-linked:focus{
    outline: none;
    box-shadow: none;
    border: 1px solid #949494;
}
.softlite-border-control button{
    margin-bottom: 8px;
    height: auto;
    min-height: 32px;
    border-radius: unset;
}
button.softlite-linked{
    background-color: #dedede;
}
.softlite-label-border-width{
    margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/border/border.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".softlite-border-dimension-control {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-top: 10px;\r\n}\r\n\r\n.softlite-border-dimension-control .components-text-control {\r\n    flex: 1;\r\n    margin-right: 5px;\r\n}\r\n\r\n.softlite-border-dimension-control .components-button {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 30px;\r\n    padding: 0;\r\n}\r\n\r\n.softlite-border-dimension-control .linked {\r\n    background-color: #007cba;\r\n    color: white;\r\n}\r\n.softlite-no-border-right .components-input-control__container input.components-input-control__input{\r\n    border-right: none;\r\n}\r\n.softlite-border-control .components-input-control__container input.components-input-control__input{\r\n    border-radius: 0px;\r\n    border: 1px solid #949494;\r\n    border-right: none;\r\n}\r\n.softlite-border-control .components-input-control__container input.components-input-control__input:focus{\r\n    border: 1px solid #949494;\r\n    border-right: none;\r\n    outline: none;\r\n    box-shadow: none;\r\n}\r\n.softlite-no-border-right .components-input-control__container input.components-input-control__input:focus{\r\n    border-right: none;\r\n}\r\n.softlite-button-linked{\r\n    border: 1px solid #949494;\r\n    outline: none;\r\n}\r\n.softlite-border-control button.softlite-button-linked:focus{\r\n    outline: none;\r\n    box-shadow: none;\r\n    border: 1px solid #949494;\r\n}\r\n.softlite-border-control button{\r\n    margin-bottom: 8px;\r\n    height: auto;\r\n    min-height: 32px;\r\n    border-radius: unset;\r\n}\r\nbutton.softlite-linked{\r\n    background-color: #dedede;\r\n}\r\n.softlite-label-border-width{\r\n    margin-bottom: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
